import { requestJson } from "./apiClient";

export function getProfile() {
  return requestJson("/api/account/profile");
}

export function updateProfile(payload) {
  return requestJson("/api/account/profile", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function getAuthProviders() {
  return requestJson("/api/account/auth-providers");
}

export function changePassword(payload) {
  return requestJson("/api/account/change-password", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getPreferences() {
  return requestJson("/api/account/preferences");
}

export function updatePreferences(payload) {
  return requestJson("/api/account/preferences", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}
